import React from "react";

const OPEN_MAPS_LINK_STYLE = Object.freeze({
  position: "absolute",
  right: "16px",
  bottom: "16px",
  zIndex: 5,
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "10px 14px",
  borderRadius: "999px",
  background: "rgba(10, 10, 10, 0.82)",
  color: "#fff",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: 1,
  textDecoration: "none",
  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.24)",
});

const getSafeExternalUrl = (value) => {
  const input = String(value || "").trim();
  if (!input) return "";

  try {
    const parsed = new URL(input);
    return ["http:", "https:"].includes(parsed.protocol)
      ? parsed.toString()
      : "";
  } catch {
    return "";
  }
};

const getCoordinateMapsUrl = (latitudeValue, longitudeValue) => {
  const hasLatitude =
    latitudeValue !== null &&
    latitudeValue !== undefined &&
    latitudeValue !== "";
  const hasLongitude =
    longitudeValue !== null &&
    longitudeValue !== undefined &&
    longitudeValue !== "";

  if (!hasLatitude || !hasLongitude) return "";

  const latitude = Number(latitudeValue);
  const longitude = Number(longitudeValue);
  const valid =
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    latitude >= -90 &&
    latitude <= 90 &&
    longitude >= -180 &&
    longitude <= 180;

  if (!valid) return "";

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${latitude},${longitude}`,
  )}`;
};

const isEmbedUrl = (value) => {
  if (!value) return false;

  try {
    const parsed = new URL(value);
    return (
      parsed.searchParams.get("output") === "embed" ||
      parsed.pathname.includes("/maps/embed")
    );
  } catch {
    return false;
  }
};

export const resolveOpenMapsUrl = ({ url, latitude, longitude }) => {
  const safeConfiguredUrl = getSafeExternalUrl(url);

  if (safeConfiguredUrl && !isEmbedUrl(safeConfiguredUrl)) {
    return safeConfiguredUrl;
  }

  return getCoordinateMapsUrl(latitude, longitude);
};

export default function OpenMapsLink({
  url,
  latitude,
  longitude,
  venueName = "venue",
  label = "Open in Maps",
}) {
  const openMapsUrl = resolveOpenMapsUrl({ url, latitude, longitude });
  if (!openMapsUrl) return null;

  return (
    <a
      href={openMapsUrl}
      target="_blank"
      rel="noreferrer"
      aria-label={`Open ${venueName} in Google Maps`}
      style={OPEN_MAPS_LINK_STYLE}
    >
      <span>{label}</span>
      <span aria-hidden="true">↗</span>
    </a>
  );
}
